import './common_lists_component.scss'

import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = []

  show () {
    this.element.classList.add('common_lists--selected')
  }

  hide () {
    this.element.classList.remove('common_lists--selected')
  }

  get categoryType () {
    return this.data.get('categoryType')
  }
}
